import {useState} from 'react';
import {useTheme} from 'styled-components';

import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';

import {UsePreviousProviderCardProps} from './types';

export function usePreviousProviderCard({dates, flowType}: UsePreviousProviderCardProps) {
	const {colors} = useTheme();
	const {specialtyCode, subSpecialtyCode} = useBookingStore(state => state.bookingData);
	const [isExpanded, setIsExpanded] = useState(false);

	const hasMultipleDates = dates.length > 1;
	const visibleDates = hasMultipleDates && !isExpanded ? dates.slice(0, 1) : dates;
	const showFavoriteButton = flowType === FlowEnum.HEALTH || flowType === FlowEnum.TELEHEALTH;

	const toggleExpanded = () => {
		setIsExpanded(prev => !prev);
	};

	return {
		colors,
		specialtyCode,
		subSpecialtyCode,
		isExpanded,
		hasMultipleDates,
		visibleDates,
		showFavoriteButton,
		toggleExpanded,
	};
}
